/**
 * Heil Ginseng Theme JavaScript
 */

(function() {
  'use strict';

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      
      e.preventDefault();
      const target = document.querySelector(href);
      
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // Lazy load images
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            observer.unobserve(img);
          }
        }
      });
    });

    document.querySelectorAll('img[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
  }

  // Simple mobile menu toggle (if needed later)
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  
  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('is-open');
    });
  }

  // Judge.me review form ownership stays inside templates/product.liquid.

  // Add to cart (basic - will enhance later)
  document.querySelectorAll('[data-add-to-cart]').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const productId = this.dataset.productId;
      const quantity = this.dataset.quantity || 1;
      
      // Simple add to cart (Shopify AJAX API)
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: productId,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Added to cart:', data);
        // Update cart count (basic - will enhance later)
        const cartLink = document.querySelector('.cart-link');
        if (cartLink) {
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              cartLink.textContent = `Cart (${cart.item_count})`;
            });
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
    });
  });

  console.log('Heil Ginseng theme initialized');
})();
